module.exports = __webpack_public_path__ + "img/Lavender_Logo_RGB1.bf76f6de.jpeg";